import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { Dialog } from "../../../../Resources/Scripts/_Shared/elements/Dialog";
import { refreshlogin } from "./Endpoints";

function LogoutTimer(context) {
  const appContainer = context;
  const appConfig = controller.getConfig(context);

  const App = () => {
    const lang = appConfig.localization;
    const duration = 40; // Total duration for when dialog is triggered and expire, specified in minutes

    const [dateLockedUntil, setDateLockedUntil] = useState(null);
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
      if (timeLeft === null) return;

      let timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      if (timeLeft.none) {
        clearTimeout(timer);
      }

      return () => clearTimeout(timer);
    });

    const calculateTimeLeft = (date = dateLockedUntil) => {
      const difference = date - +new Date();
      let timeLeft = {};

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      } else {
        timeLeft = {
          none: true
        };
      }

      return timeLeft;
    };

    const handleDialogConfirm = async () => {
      const response = await refreshlogin();
      if (response.status === 200) {
        if (response.body !== true) location.reload();
        const expiration = moment(new Date()).add(duration, 'm');
        setDateLockedUntil(expiration);
        setTimeLeft(calculateTimeLeft(expiration));
      } else {
        location.reload();
      }
    }

    if (!timeLeft) {
      const expiration = moment(new Date()).add(duration, 'm');
      setDateLockedUntil(expiration);
      setTimeLeft(calculateTimeLeft(expiration));
    }

    if (timeLeft !== null && !timeLeft.none && timeLeft.minutes < 5) {
      return (
        <Dialog lang={lang} onDialogConfirm={handleDialogConfirm}>
          <p>{lang.message1} {timeLeft.minutes > 0 && timeLeft.minutes} {timeLeft.minutes > 0 && (timeLeft.minutes === 1 ? lang.minute : lang.minutes)} {timeLeft.minutes > 0 && lang.and} {timeLeft.seconds} {timeLeft.seconds === 1 ? lang.second : lang.seconds} {lang.message2}</p>
        </Dialog>
      )
    }

    if (timeLeft !== null && timeLeft.none) {
      window.location.replace(appConfig.url.signout)
    }

    return null;
  }

  function init() {
    ReactDOM.render(<App />, appContainer);
  }

  return {
    init
  };

}

controller.add('logout-timer', LogoutTimer);